import { useTranslation } from 'react-i18next';
import { subMonths } from 'date-fns';
import { useQueryClient } from '@tanstack/react-query';

import { useAppSelector } from '@/hooks';
import useNotification from '@/hooks/useNotification';
import {
  activeCompanySelector,
  queryKeySelector,
} from '@/core/store/user/userSlice';
import { formatDate } from '@/core/helpers';
import { postNoManualDataNeeded } from '@/core/api';

import ConfirmModal from '../ConfirmModal/ConfirmModal';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
}

export const StopMUModal = ({ isModalOpened, closeModal }: Props) => {
  const { t } = useTranslation();
  const { showNotification } = useNotification();
  const activeCompany = useAppSelector(activeCompanySelector);
  const queryClient = useQueryClient();
  const queryKey = useAppSelector(queryKeySelector);
  return (
    <ConfirmModal
      isModalOpened={isModalOpened}
      closeModal={closeModal}
      confirm={(setIsLoading) => {
        setIsLoading(true);
        postNoManualDataNeeded(activeCompany?.company_id)
          .then(() => {
            queryClient.invalidateQueries({
              queryKey: ['SellerDataUnits', queryKey],
            });
            setIsLoading(false);
            closeModal();
            showNotification({
              text: 'No manual turnover data confirmed',
              type: 'success',
            });
          })
          .catch(() => {
            setIsLoading(false);
          });
      }}
      confirmBtnText='Yes, I confirm'
      title='Confirm action'
    >
      <>
        <div className='Text mb-2 font-black'>
          {t(
            'Please confirm that there is no manual turnover data for *month*'
          ).replace(
            '*month*',
            formatDate(subMonths(new Date(), 1), 'MMMM yyyy')
          )}
        </div>
        <div className='mb-4'>
          {t(
            'In this case we will submit zero VAT return and you will not receive any email reminders in the current month.'
          )}
        </div>
      </>
    </ConfirmModal>
  );
};
